import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Circle, X, Rocket } from "lucide-react";
import api from "../../lib/api";

const ITEMS = [
  ["finances", "Saisir mes charges", "/app/finances?guide=finances"],
  ["bank", "Connecter ma banque", "/app/finances/rapprochement?guide=bank"],
  ["loans", "Ajouter mon prêt", "/app/finances/prets?guide=loans"],
  ["forecast", "Voir mon prévisionnel", "/app/finances/bilan?guide=forecast"],
  ["valuation", "Estimer mes biens", "/app/finances/bilan?guide=valuation"],
];

export const GoFurtherChecklist = ({ onHide }) => {
  const nav = useNavigate();
  const [ready, setReady] = useState(false);
  const [mods, setMods] = useState(null);
  useEffect(() => {
    api.get("/onboarding/state").then((r) => setReady(r.data.has_lease && !r.data.has_example)).catch(() => {});
    api.get("/guides/status").then((r) => setMods(r.data.modules)).catch(() => {});
  }, []);
  if (!ready || !mods) return null;
  const done = ITEMS.filter(([k]) => mods[k]?.done || mods[k]?.status === "completed").length;
  if (done === ITEMS.length) return null;
  return (
    <div className="bg-white border border-brand-soft rounded-2xl px-5 py-4" data-testid="go-further-checklist">
      <div className="flex items-center gap-3 mb-2">
        <Rocket className="w-5 h-5 text-brand-limeDark" />
        <p className="flex-1 font-semibold text-brand-greenDeep">Aller plus loin · {done}/{ITEMS.length}</p>
        <button onClick={onHide} title="Masquer (réaffichable via « Personnaliser »)" className="text-brand-green/40 hover:text-brand-greenDeep" data-testid="go-further-hide"><X className="w-4 h-4" /></button>
      </div>
      <div className="grid sm:grid-cols-5 gap-2">
        {ITEMS.map(([k, label, url]) => {
          const ok = mods[k]?.done || mods[k]?.status === "completed";
          return (
            <button key={k} disabled={ok} onClick={() => nav(url)} className={`flex items-center gap-2 px-3 py-2.5 rounded-xl text-left text-sm ${ok ? "text-brand-green/40 line-through" : "bg-brand-softer hover:bg-brand-soft text-brand-greenDeep font-medium"}`} data-testid={`go-further-${k}`}>
              {ok ? <CheckCircle2 className="w-4 h-4 text-brand-limeDark shrink-0" /> : <Circle className="w-4 h-4 text-brand-green/30 shrink-0" />}{label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
